import * as React from 'react';
import { registerDocumentTitleStatusChanged, unregisterDocumentTitleStatusChanged, } from './updateDocumentTitleStatus';
import { getDocumentTitleLabelStyles, getStatusWrapperClassName, getDocumentTitleToolTipStyles, } from './DocumentTitleStatusLabel.Styles';
import { performOnNextFrame } from '@ms/app-commanding-ui/lib/utilities';
import { FriendlyDateFormatter } from '@ms/office-online-shared-friendlydates/lib/';
import { TooltipHost, TooltipDelay } from '@fluentui/react/lib/Tooltip';
import { DirectionalHint } from '@fluentui/react';
var getFriendlyTimeString = function (prefix, timeToConvert) {
    if (timeToConvert) {
        var windowculture = window.navigator.language.toLocaleLowerCase();
        var friendlyTime = new FriendlyDateFormatter(windowculture, windowculture, friendlyDatesStrings).format(timeToConvert);
        return prefix.replace('{0}', friendlyTime);
    }
    return '';
};
var getTimeString = function (prefix, timeToConvert) {
    if (timeToConvert) {
        var windowculture = window.navigator.language.toLocaleLowerCase();
        var timeString = Intl.DateTimeFormat(windowculture, {
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        }).format(lastSavedTimeForTooltip);
        return prefix.replace('{0}', timeString);
    }
    return '';
};
var lastSavedTimeForTooltip;
var lastSavedTimeStampString;
var lastSavedTimeStampMade;
var friendlyDatesStrings;
var tooltipProps = {
    onRenderContent: function () { return React.createElement("span", null, getFriendlyTimeString(lastSavedTimeStampString, lastSavedTimeForTooltip)); },
};
export var DocumentTitleStatusLabel = React.memo(function (props) {
    var measuredTexts = React.useRef(new Set());
    var statusWrapperRef = React.useRef(null);
    var maxStatusWrapperClientWidth = React.useRef(undefined);
    var _a = React.useState({ stateUpdated: false }), state = _a[0], setState = _a[1];
    var measureSaveButtonWidth = function () {
        // Note that the string prop saveStatus itself is not enough to measure the rendered width
        // We need to wait for next frame to measure the width
        if (statusWrapperRef.current && saveStatus && !measuredTexts.current.has(saveStatus)) {
            measuredTexts.current.add(saveStatus);
            var clientWidth = statusWrapperRef.current.clientWidth;
            if (!maxStatusWrapperClientWidth.current || clientWidth > maxStatusWrapperClientWidth.current) {
                maxStatusWrapperClientWidth.current = clientWidth;
            }
        }
    };
    var onDocumentTitleStatusChanged = function (data) {
        var isHidden = data.isHidden, mode = data.mode, saveStatus = data.saveStatus, lastSavedTime = data.lastSavedTime;
        setState({
            hideMode: isHidden,
            hideSaveStatus: isHidden,
            mode: mode,
            saveStatus: saveStatus,
            stateUpdated: true,
            lastSavedTime: lastSavedTime,
        });
    };
    React.useEffect(function () {
        performOnNextFrame(measureSaveButtonWidth);
    });
    React.useEffect(function () {
        var updateDocumentTitleStatusEventListener = registerDocumentTitleStatusChanged(onDocumentTitleStatusChanged);
        return function cleanup() {
            if (updateDocumentTitleStatusEventListener) {
                unregisterDocumentTitleStatusChanged(updateDocumentTitleStatusEventListener);
            }
        };
    }, []);
    var mode = state.stateUpdated ? state.mode : props.mode;
    var hideMode = state.stateUpdated ? state.hideMode : props.hideMode;
    var saveStatus = state.stateUpdated ? state.saveStatus : props.saveStatus;
    var hideSaveStatus = state.stateUpdated ? state.hideSaveStatus : props.hideSaveStatus;
    var documentTitleStyles = getDocumentTitleLabelStyles();
    var isSaveStatusVisible = !hideSaveStatus && saveStatus;
    var statusWrapperClassName = getStatusWrapperClassName(isSaveStatusVisible ? maxStatusWrapperClientWidth.current : undefined);
    function baseTitleStatusLabel() {
        return (React.createElement("div", { ref: statusWrapperRef, className: statusWrapperClassName, "aria-label": getTimeString(lastSavedTimeStampString, lastSavedTimeForTooltip) },
            React.createElement("span", null,
                mode && !hideMode && (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: documentTitleStyles.documentTitleSeparator }, "-"),
                    React.createElement("span", { className: documentTitleStyles.status }, mode))),
                saveStatus && !hideSaveStatus && (React.createElement("span", { className: documentTitleStyles.statusWrapper },
                    React.createElement("span", { className: documentTitleStyles.documentTitleSeparator }, "-"),
                    React.createElement("span", { className: documentTitleStyles.status, "data-unique-id": "DocumentTitleSaveStatus" }, saveStatus))))));
    }
    var tooltipId = 'LastSavedTooltip';
    if (state.lastSavedTime && props.strings.lastSavedTimestampPrefix && props.strings.friendlyDatesStrings) {
        lastSavedTimeForTooltip = state.lastSavedTime;
        lastSavedTimeStampString = props.strings.lastSavedTimestampPrefix;
        lastSavedTimeStampMade = true;
        friendlyDatesStrings = props.strings.friendlyDatesStrings;
    }
    if (lastSavedTimeStampMade) {
        return (React.createElement(TooltipHost, { tooltipProps: tooltipProps, delay: TooltipDelay.zero, id: tooltipId, directionalHint: DirectionalHint.bottomCenter, styles: getDocumentTitleToolTipStyles() }, baseTitleStatusLabel()));
    }
    return React.createElement(React.Fragment, null, baseTitleStatusLabel());
});
//# sourceMappingURL=DocumentTitleStatusLabel.js.map